export * from './statdocs.component';
